import { InputNumber as $InputNumber } from 'antd';
import { InputNumberProps as $InputNumberProps } from 'antd/lib/input-number';
import React from 'react';

import { OnBlurCallback, OnChangeCallback } from '.';

import { NumberType } from '../../types/form';

export type NumberInputProps = Omit<$InputNumberProps, 'onBlur' | 'onChange'> & {
  valueType?: NumberType;
  onBlur?: OnBlurCallback;
  onChange?: OnChangeCallback;
};

const NumberInput = React.memo(function NumberInput({
  name,
  valueType = NumberType.Decimal,
  precision: precisionProp,
  onBlur,
  onChange,

  ...props
}: NumberInputProps) {
  let precision = precisionProp;
  if (valueType === NumberType.Integer) {
    precision = 0;
  }

  const handleBlur =
    onBlur &&
    ((event: React.FocusEvent<HTMLInputElement>) => {
      const {
        target: { value },
      } = event;
      // `value` is always string
      const newVal = value === '' ? undefined : Number(value);
      if (newVal === undefined || !isNaN(newVal)) {
        onBlur({ name, value: newVal });
      }
    });
  const handleChange =
    onChange &&
    ((value?: number | string | null) => {
      // explicitly set to `undefined`
      const newVal = value === null || value === '' ? undefined : value;
      if (newVal === undefined || typeof newVal === 'number') {
        onChange({ name, value: newVal });
      }
    });

  const formatter = (value: number | string | undefined) => (value ? `${value}`.replace(/[^0-9,.-]+/g, '') : '');

  return (
    <$InputNumber
      {...props}
      name={name}
      precision={precision}
      onBlur={handleBlur}
      onChange={handleChange}
      formatter={formatter}
    />
  );
});

export default NumberInput;
